import React from "react";

const TimeLineTargetCondicionado = ({
    title,
    subtitle,
    icon,
    footer,
    starttarget,
    endtarget,
    color,
    openModal,
    active,
    value,
    setValue,
    seleccionado,
    setSeleccionado,
}) => {
    const onOpenModal = () => {
        if (
            openModal !== undefined &&
            openModal !== null &&
            typeof openModal === "function" &&
            color !== undefined &&
            color !== null &&
            color !== "disabled"
        ) {
            setValue(value);
            openModal(true);
            setSeleccionado(value)
        }
    };
    return (

        <div
            className={`${active === undefined ||
                active === null ||
                typeof active !== "boolean" ||
                active === false
                ? "analisis-sc-procesos-target"
                : "analisis-sc-procesos-target analisis-sc-procesos-target-active"
                }`}
        >
            <div
                className={`${value === seleccionado
                    ? " analisis-sc-procesos-target-select"
                    : ""
                    }`}
            >
                {starttarget !== undefined && starttarget !== null && (
                    <div className="analisis-sc-procesos-conector-start" />
                )}

                {(endtarget === undefined || endtarget === null) && (
                    <div
                        className={`analisis-sc-procesos-conector analisis-sc-procesos-conector-${color}`}
                    />
                )}

                <div className="analisis-sc-procesos-target-title">{title}</div>
                <div className="analisis-sc-procesos-target-subtitle">{subtitle}</div>
                <div className="analisis-sc-procesos-target-icon">
                    <div
                        className={`analisis-sc-procesos-target-icon-circle analisis-sc-procesos-target-icon-circle-${color}`}
                        onClick={() => onOpenModal()}
                    >
                        {icon}
                    </div>
                </div>
                <div className="analisis-sc-procesos-target-footer">
                    <div>{footer.tiempoestimado}</div>
                    <div>{footer.leyenda}</div>
                    <div>{footer.duracion}</div>
                    <div>{footer.comentarios}</div>
                </div>
            </div>
        </div>
    );
};

export default TimeLineTargetCondicionado;
